<template>
  <p>
    <span class="modal-body-text"
      >You are about to remove activity {{ name }} from program.</span
    ><br /><br />
    <span class="modal-body-text">Are you sure you want to continue?</span>
    <br />
  </p>
</template>

<script>
export default {
  name: "remove-custom-activity-modal",
  props: {
    data: null
  },
  computed: {
    name() {
      return this.data ? `${this.data.title}` : "this activity";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal/RemoveCustomActivity.vue